import DivContainerBody from '../../../../../components/DivContainerBody';
import StepperTabs from '../../../../../components/StepperTabs/StepperTabs';
import StepTab from '../../../../../components/StepperTabs/StepTab';
import routes from '../../../../../Routes/routes';
import HeadTittle from '../../../../../components/HeadTittle';
import { ButtonNextStep, ButtonPrevStep } from '../../../../../components/buttons/ButtonNavigation';
import CreateDishApp from '../Functionality/CreateDishApp';
import StepSetUp from './StepSetUp';
import DishSummary from './DishSummary';
import Ingredients from './Ingredients';
import Allergens from './Allergens';
import CustomPhotoPicker from '../../../../../components/PhotoPicker/CustomPhotoPicker';
import { ACTION_MODEL } from '../../../../../Helpers/ActionModel';
import { FILE_TYPE } from '../../../../../Helpers/fileType';
import { SUGGESTION_MODE_OPTION } from '../../../../../components/PhotoPicker/SubComponent/Models/Models';

/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 */
const CreateDish = () => {
    const {
        t,
        disabled,
        activeStep,
        setActiveStep,
        steps,
        handleStepChange,
        handleStepSetUp,
        dishData,
        selectedAllergens,
        setSelectedAllergens,
        selectedDietTypes,
        setSelectedDietTypes,
        selectedIngredients,
        setSelectedIngredients,
        handleCreate,
        photoPicker,
        setPhotoPicker,
        emptyFields,
        item,
        setItem,
        handleChange,
        errorCode,
        errorName,
        setEmptyFields,
        setIsValid,
    } = CreateDishApp();
    return (
        <>
            <HeadTittle link={routes.foodie.list} name={'create'} />
            <>
                <StepperTabs
                    id={null}
                    disabled={false}
                    steps={steps}
                    activeStep={activeStep}
                    isStepOptional={(step) => step == 3}
                    setActiveStep={setActiveStep}
                    handleStepChange={handleStepChange}
                >
                    <StepTab index={0} activeStep={activeStep} scroll={false}>
                        <div className='row'>
                            <StepSetUp
                                item={item}
                                disabled={disabled}
                                emptyFields={emptyFields}
                                handleChange={handleChange}
                                errorCode={errorCode}
                                errorName={errorName}
                            />
                        </div>
                        <div className='col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6'>
                            <ButtonNextStep
                                id='btn_cd_next_dish'
                                text='next'
                                click={() => {
                                    if (!item.isValidSetUpData()) {
                                        setEmptyFields(true);
                                        return false;
                                    }

                                    setEmptyFields(false);
                                    setIsValid(true);
                                    setActiveStep((prevStep) => prevStep + 1);
                                }}
                            />
                        </div>
                    </StepTab>
                    <StepTab index={1} activeStep={activeStep} scroll={false}>
                        <div className='row'>
                            <div className='row mb-4'>
                                <Ingredients
                                    t={t}
                                    ingredients={[]}
                                    item={item}
                                    setItem={setItem}
                                    disabled={disabled}
                                    handleChange={handleChange}
                                    selectedIngredients={selectedIngredients}
                                    setSelectedIngredients={setSelectedIngredients}
                                    emptyFields={emptyFields}
                                />
                            </div>
                        </div>
                        <div className='d-flex justify-content-between px-0 mt-3'>
                            <ButtonPrevStep
                                id='btn_cd_back_file'
                                text='back'
                                click={() => setActiveStep((prevStep) => prevStep - 1)}
                            />
                            <ButtonNextStep
                                id='btn_aei_next_file'
                                text='next'
                                disabled={activeStep === steps.length - 1}
                                click={() => {
                                    if (handleStepSetUp()) {
                                        setActiveStep((prevStep) => prevStep + 1);
                                    }
                                }}
                            />
                        </div>
                    </StepTab>
                    <StepTab index={2} activeStep={activeStep} scroll={false}>
                        <Allergens
                            t={t}
                            item={item}
                            setItem={setItem}
                            disabled={disabled}
                            handleChange={handleChange}
                            selectedAllergens={selectedAllergens}
                            setSelectedAllergens={setSelectedAllergens}
                            selectedDietTypes={selectedDietTypes}
                            setSelectedDietTypes={setSelectedDietTypes}
                            emptyFields={emptyFields}
                        />

                        <div className='d-flex justify-content-between px-0 mt-3'>
                            <ButtonPrevStep
                                id='btn_cd_back_file'
                                text='back'
                                click={() => setActiveStep((prevStep) => prevStep - 1)}
                            />
                            <ButtonNextStep
                                id='btn_aei_next_file'
                                text='next'
                                disabled={activeStep === steps.length - 1}
                                click={() => {
                                    if (handleStepSetUp()) {
                                        setActiveStep((prevStep) => prevStep + 1);
                                    }
                                }}
                            />
                        </div>
                    </StepTab>
                    <StepTab index={3} activeStep={activeStep} scroll={false}>
                        <CustomPhotoPicker
                            id='fp_cd_photo_file'
                            photoPicker={photoPicker}
                            setPhotoPicker={setPhotoPicker}
                            actionModel={ACTION_MODEL.CREATE}
                            accept={{ ...FILE_TYPE.IMAGE }}
                            showBtnDelete={true}
                            required={false}
                            disabled={false}
                            showBtnCamera={true}
                            validateFace={false}
                            classWith={'content-center-w-400px'}
                            showPreview={true}
                            typeSuggestions={SUGGESTION_MODE_OPTION.INGREDIENTS}
                            handleCancel={() => {
                                setActiveStep((prevStep) => prevStep + 1);
                            }}
                        />

                        <div className='d-flex justify-content-between px-0 mt-3'>
                            <ButtonPrevStep
                                id='btn_aei_back_file'
                                text='back'
                                click={() => setActiveStep((prevStep) => prevStep - 1)}
                            />
                            <ButtonNextStep
                                id='btn_cd_next_file'
                                text='next'
                                disabled={activeStep === steps.length - 1}
                                click={() => setActiveStep((prevStep) => prevStep + 1)}
                            />
                        </div>
                    </StepTab>
                    <StepTab index={4} activeStep={activeStep} scroll={false}>
                        <DishSummary
                            item={item}
                            selectedAllergens={selectedAllergens}
                            selectedDietTypes={selectedDietTypes}
                            selectedImage={photoPicker}
                            selectedIngredients={selectedIngredients}
                            dishData={dishData}
                        />
                        <div className='d-flex justify-content-between px-0 mb-2'>
                            <ButtonPrevStep
                                id='btn_cd_next_dish'
                                text='back'
                                click={() => setActiveStep((prevStep) => prevStep - 1)}
                            />
                            <ButtonNextStep
                                id='btn_aei_enroll'
                                text='create'
                                click={() => {
                                    handleCreate();
                                }}
                            />
                        </div>
                    </StepTab>
                </StepperTabs>
            </>
        </>
    );
};

export default CreateDish;
